import * as React from 'react';
import { FC, useState } from 'react';
import type { QuickSignupFormProps, Values, ChangeValues } from './types';
import Error from './Error';
import Email from './Email';
import Login from './Login';
import Password from './Password';
import Currency from './Currency';
import Country from './Country';
import Terms from './Terms';
import Mature from './Adult';
import SignupCode from './SignupCode';
import SubmitButton from './SubmitButton';
import useFormValidation from './useFormValidation';
import useFormSubmit from './useFormSubmit';

const QuickSignupForm: FC<QuickSignupFormProps> = ({
  currencies,
  initial_currency,
  countries,
  initial_country,
  locales,
}) => {
  const [values, setValues] = useState<Values>({
    email: '',
    login: '',
    password: '',
    currency: initial_currency,
    country: initial_country,
    terms: false,
    adult: false,
    signup_code: '',
  });
  const changeValues: ChangeValues = (v: Partial<Values>) => setValues((prev) => ({ ...prev, ...v }));

  const [isValid, isEmailValidating, isLoginValidating, isSignupCodeValidating, errors] = useFormValidation(
    values,
    locales
  );
  const [submit, isSubmitting, submitError] = useFormSubmit(values);

  const args = { values, changeValues, errors, locales };

  return (
    <form
      className="simple_form form-centered xo-form"
      action="/players/quick_sign_up"
      acceptCharset="UTF-8"
      method="post"
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
    >
      <Error error={submitError} />

      <Email {...args} isValidating={isEmailValidating} />
      <Login {...args} isValidating={isLoginValidating} />
      <Password {...args} />
      <div className="rs-column-large-12 xo-form_selects">
        <Currency {...args} currencies={currencies} />
        <Country {...args} countries={countries} />
      </div>
      <SignupCode {...args} isValidating={isSignupCodeValidating} />
      <Terms {...args} />
      <Mature {...args} />

      <SubmitButton isValid={isValid} isSubmitting={isSubmitting} locales={locales} />
    </form>
  );
};

const Wrapper: FC<QuickSignupFormProps> = (props) => {
  document.getElementById('quick-signup-form-loader')?.remove();
  return <QuickSignupForm {...props} />;
};

export default Wrapper;
